/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_DescriptionInputs */

const en_landing_pricing_description = /** @type {(inputs: Landing_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy credits once or subscribe. Credits are spent only when you generate a duet video.`)
};

/**
* | output |
* | --- |
* | "Buy credits once or subscribe. Credits are spent only when you generate a duet video." |
*
* @param {Landing_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_pricing_description = /** @type {((inputs?: Landing_Pricing_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_pricing_description(inputs)
});
export { landing_pricing_description as "landing.pricing.description" }